export default (date, options) => (
  date ? new Date(date).toLocaleDateString(document.documentElement.lang, options) : ''
);
